import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Alert, Button, Col, Form, Row } from 'antd';
import { Link } from 'react-router-dom';

import AntIcon from '../../shared/components/AntIcon';
import BannerImageField from './BannerImageField';
import ShoesImageField from './ShoesImageField';
import { renderDateTime, renderInput, renderNumberInput, renderSelect } from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';
import { GIVEAWAY_STATUS_OPTIONS } from '../status';

const slugMonth = (value) =>
  value && !/^\d{4}-\d{2}$/.test(value) ? 'Use YYYY-MM format' : undefined;

const winnerCountRange = (value) => {
  if (value === undefined || value === null || value === '') return undefined;
  const n = Number(value);
  if (!Number.isFinite(n) || !Number.isInteger(n)) return 'Enter a whole number';
  if (n < 1 || n > 20) return 'Must be between 1 and 20';
  return undefined;
};

class CampaignForm extends Component {
  render() {
    const {
      cancelPath,
      deleteError,
      error,
      extraActions,
      handleSubmit,
      saveLabel,
      submitting,
    } = this.props;
    const err = deleteError || error;

    // Native <form> is required so htmlType="submit" reliably fires redux-form's handleSubmit.
    // Ant Design <Form> defaults to a <form> but its submit handling can swallow / not forward
    // events consistently with redux-form; nesting layout in component="div" avoids double <form>.
    return (
      <form className="ant-form ant-form-horizontal" onSubmit={handleSubmit} noValidate>
        <Form layout="horizontal" component="div">
          <Row>
            <Col lg={18} xs={24}>
            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button htmlType="button">
                    <Link to={cancelPath || '/giveaway'}>Cancel</Link>
                  </Button>
                </Col>
                {extraActions}
                <Col>
                  <Button
                    disabled={submitting}
                    loading={submitting}
                    type="primary"
                    htmlType="button"
                    onClick={handleSubmit}
                  >
                    <AntIcon type="save" />{saveLabel || 'Save'}
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {err && <Form.Item><Alert message={err} type="error" /></Form.Item>}

            <Field
              name="title"
              label="Title"
              placeholder="May 2026 Sneaker Giveaway"
              component={renderInput}
              validate={required}
              required
            />

            <Field
              name="slugMonth"
              label="Slug Month"
              placeholder="2026-05"
              component={renderInput}
              validate={[required, slugMonth]}
              required
              extra="Use YYYY-MM so the frontend matches the backend's monthly slug format."
            />

            <Field
              name="bannerImage"
              label="Banner Image"
              component={BannerImageField}
              validate={url}
              extra="Upload an image (saved to the server) or paste a full image URL."
            />

            <Field
              name="shoesImage"
              label="Shoes Image"
              component={ShoesImageField}
              extra="Choose an image file to send with create/update. The API saves it under /uploads/campaignImages/ and returns the public URL."
            />

            <Field
              name="selectionDateUtc"
              label="Selection Date (UTC)"
              component={renderDateTime}
              validate={required}
              required
              showTime
              pickerFormat="YYYY-MM-DD HH:mm"
              extra="Stored in UTC. Pick the exact UTC date/time when the winner should be selected."
            />

            <Field
              name="winnerCount"
              label="Number of winners"
              component={renderNumberInput}
              validate={[required, winnerCountRange]}
              required
              min={1}
              max={20}
              precision={0}
              extra="How many winners must be selected for this campaign."
            />

            <Field
              name="status"
              label="Status"
              component={renderSelect}
              options={GIVEAWAY_STATUS_OPTIONS}
              validate={required}
              required
            />
          </Col>
        </Row>
        </Form>
      </form>
    );
  }
}

export default reduxForm({
  form: 'GiveawayCampaignFormV5',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(CampaignForm);
